import {
  CREATE_RETAIL_PROFILE,
  CREATE_RETAIL_PROFILE_SUCCESS,
  CREATE_RETAIL_PROFILE_FAILED,
  GET_RETAIL_PROFILES,
  GET_RETAIL_PROFILES_SUCCESS,
  GET_RETAIL_PROFILES_FAILED,
  GET_RETAIL_PROFILE_BY_ID,
  GET_RETAIL_PROFILE_BY_ID_SUCCESS,
  GET_RETAIL_PROFILE_BY_ID_FAILED,
  GET_RETAIL_PROFILES_BY_VENUE,
  GET_RETAIL_PROFILES_BY_VENUE_SUCCESS,
  GET_RETAIL_PROFILES_BY_VENUE_FAILED,
  UPDATE_RETAIL_PROFILE,
  UPDATE_RETAIL_PROFILE_SUCCESS,
  UPDATE_RETAIL_PROFILE_FAILED,
  DELETE_RETAIL_PROFILE,
  DELETE_RETAIL_PROFILE_SUCCESS,
  DELETE_RETAIL_PROFILE_FAILED,
  CREATE_RETAIL_SCHEDULE,
  CREATE_RETAIL_SCHEDULE_SUCCESS,
  CREATE_RETAIL_SCHEDULE_FAILED,
  GET_SCHEDULES_BY_PROFILE,
  GET_SCHEDULES_BY_PROFILE_SUCCESS,
  GET_SCHEDULES_BY_PROFILE_FAILED,
  GET_SCHEDULES_BY_DAY,
  GET_SCHEDULES_BY_DAY_SUCCESS,
  GET_SCHEDULES_BY_DAY_FAILED,
  UPDATE_RETAIL_SCHEDULE,
  UPDATE_RETAIL_SCHEDULE_SUCCESS,
  UPDATE_RETAIL_SCHEDULE_FAILED,
  DELETE_RETAIL_SCHEDULE,
  DELETE_RETAIL_SCHEDULE_SUCCESS,
  DELETE_RETAIL_SCHEDULE_FAILED,
  SET_CURRENT_RETAIL_PROFILE,
  CLEAR_RETAIL_PROFILE_STATE,
} from './constants';

// Retail Profile Actions
export const createRetailProfile = (profileData, navigate) => ({
  type: CREATE_RETAIL_PROFILE,
  payload: { profileData, navigate },
});

export const createRetailProfileSuccess = (profile) => ({
  type: CREATE_RETAIL_PROFILE_SUCCESS,
  payload: { profile },
});

export const createRetailProfileFailed = (error) => ({
  type: CREATE_RETAIL_PROFILE_FAILED,
  payload: { error },
});

export const getRetailProfiles = () => ({
  type: GET_RETAIL_PROFILES,
});

export const getRetailProfilesSuccess = (profiles) => ({
  type: GET_RETAIL_PROFILES_SUCCESS,
  payload: { profiles },
});

export const getRetailProfilesFailed = (error) => ({
  type: GET_RETAIL_PROFILES_FAILED,
  payload: { error },
});

export const getRetailProfileById = (id) => ({
  type: GET_RETAIL_PROFILE_BY_ID,
  payload: { id },
});

export const getRetailProfileByIdSuccess = (profile) => ({
  type: GET_RETAIL_PROFILE_BY_ID_SUCCESS,
  payload: { profile },
});

export const getRetailProfileByIdFailed = (error) => ({
  type: GET_RETAIL_PROFILE_BY_ID_FAILED,
  payload: { error },
});

export const getRetailProfilesByVenue = (venueId) => ({
  type: GET_RETAIL_PROFILES_BY_VENUE,
  payload: { venueId },
});

export const getRetailProfilesByVenueSuccess = (profiles) => ({
  type: GET_RETAIL_PROFILES_BY_VENUE_SUCCESS,
  payload: { profiles },
});

export const getRetailProfilesByVenueFailed = (error) => ({
  type: GET_RETAIL_PROFILES_BY_VENUE_FAILED,
  payload: { error },
});

export const updateRetailProfile = (id, profileData) => ({
  type: UPDATE_RETAIL_PROFILE,
  payload: { id, profileData },
});

export const updateRetailProfileSuccess = (profile) => ({
  type: UPDATE_RETAIL_PROFILE_SUCCESS,
  payload: { profile },
});

export const updateRetailProfileFailed = (error) => ({
  type: UPDATE_RETAIL_PROFILE_FAILED,
  payload: { error },
});

export const deleteRetailProfile = (id) => ({
  type: DELETE_RETAIL_PROFILE,
  payload: { id },
});

export const deleteRetailProfileSuccess = (id) => ({
  type: DELETE_RETAIL_PROFILE_SUCCESS,
  payload: { id },
});

export const deleteRetailProfileFailed = (error) => ({
  type: DELETE_RETAIL_PROFILE_FAILED,
  payload: { error },
});

// Retail Schedule Actions
export const createRetailSchedule = (scheduleData) => ({
  type: CREATE_RETAIL_SCHEDULE,
  payload: { scheduleData },
});

export const createRetailScheduleSuccess = (schedule) => ({
  type: CREATE_RETAIL_SCHEDULE_SUCCESS,
  payload: { schedule },
});

export const createRetailScheduleFailed = (error) => ({
  type: CREATE_RETAIL_SCHEDULE_FAILED,
  payload: { error },
});

export const getSchedulesByProfile = (profileId) => ({
  type: GET_SCHEDULES_BY_PROFILE,
  payload: { profileId },
});

export const getSchedulesByProfileSuccess = (schedules) => ({
  type: GET_SCHEDULES_BY_PROFILE_SUCCESS,
  payload: { schedules },
});

export const getSchedulesByProfileFailed = (error) => ({
  type: GET_SCHEDULES_BY_PROFILE_FAILED,
  payload: { error },
});

export const getSchedulesByDay = (profileId, day) => ({
  type: GET_SCHEDULES_BY_DAY,
  payload: { profileId, day },
});

export const getSchedulesByDaySuccess = (schedules) => ({
  type: GET_SCHEDULES_BY_DAY_SUCCESS,
  payload: { schedules },
});

export const getSchedulesByDayFailed = (error) => ({
  type: GET_SCHEDULES_BY_DAY_FAILED,
  payload: { error },
});

export const updateRetailSchedule = (id, scheduleData) => ({
  type: UPDATE_RETAIL_SCHEDULE,
  payload: { id, scheduleData },
});

export const updateRetailScheduleSuccess = (schedule) => ({
  type: UPDATE_RETAIL_SCHEDULE_SUCCESS,
  payload: { schedule },
});

export const updateRetailScheduleFailed = (error) => ({
  type: UPDATE_RETAIL_SCHEDULE_FAILED,
  payload: { error },
});

export const deleteRetailSchedule = (id) => ({
  type: DELETE_RETAIL_SCHEDULE,
  payload: { id },
});

export const deleteRetailScheduleSuccess = (id) => ({
  type: DELETE_RETAIL_SCHEDULE_SUCCESS,
  payload: { id },
});

export const deleteRetailScheduleFailed = (error) => ({
  type: DELETE_RETAIL_SCHEDULE_FAILED,
  payload: { error },
});

export const setCurrentRetailProfile = (profile) => ({
  type: SET_CURRENT_RETAIL_PROFILE,
  payload: { profile },
});

export const clearRetailProfileState = () => ({
  type: CLEAR_RETAIL_PROFILE_STATE,
});
